import { createSelector } from "reselect";
import type { makeModifier } from "../../reducers/pageModifiers/reducer";
import type { State } from "../../pages/AppStoreWrapper";

export const getModifierFormData = createSelector(
  (state: State) => state.page.modifierForm.get("data"),
  (data: ReturnType<typeof makeModifier>) => data.toObject()
);

export const getModifierFormIsExpand = createSelector(
  (state: State) => state.page.modifierForm.get("isExpand"),
  (value: boolean) => value
);
